import { TFunction } from "@languages/useTranslation";

export const handleErrorMessage = (
  fieldError: any,
  t: TFunction<"translation", undefined>
) => {
  if (!fieldError) return "";

  return t(fieldError.message.key, fieldError.message.values);
};
